module.exports = __webpack_public_path__ + "static/img/gzh.0a0af46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gzh.png
// module id = Xq3r
// module chunks = 0